// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2UF25","alert":"SettungsInbox_alert__2gmcl"};